import axios from "./axios";

export const signUp = (data) => {
  data.source = "tv"
  return new Promise((resolve, reject) => {
    axios.post("/user/create-temp-user", data)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export const additionInfo = (data) => {
  data.source = "tv"
  return new Promise((resolve, reject) => {
    axios.post("/user/update-temp-user/" + data.id, data)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}
export const createPayment = (data) => {
  const source = "tv"
  return new Promise((resolve, reject) => {
    data.description = "Description";
    data.source = source
    axios.post("/user/create-payment", data)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error.message)
      })
  })
}
export const increaseHits = (code, stype) => {
  return new Promise((resolve, reject) => {
    axios.post("/affiliate/increase-hits/" + code + "/tv/" + stype)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error.message)
      })
  })
}
export const updatePlanPayment = (data) => {
  return new Promise((resolve, reject) => {
    data.description = "Description";
    axios.post("/user/update-plan-payment", data)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error.message)
      })
  })
}
